import { handleUrl, myHeadersWithTokenContentType } from '../../global';
import { GetCitiesResponse } from './types';

export const getCities = (uf: number): Promise<GetCitiesResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/cities?uf=${uf}&all=true`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
